module.exports = __webpack_public_path__ + "images/f75b476a7a814ef442e6ccb5f430d4f7-logo_white.png";